import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "fhm-provision-button",
    templateUrl: "./provision-button.component.html",
    styleUrls: ["./provision-button.component.scss"],
    standalone: false
})
export class ProvisionButtonComponent {
    @Output() clicked: EventEmitter<any> = new EventEmitter();

    @Input() title: string;
    @Input() disabled: boolean;
}
